<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">SMS Templates</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">SMS Templates</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                name="aSms"
                data-toggle="modal"
                data-target="#sendTextv2"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <div class="table-responsive">
            <table
              id="smsList"
              data-height="300"
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
            >
              <thead class="thead-dark">
                <tr>
                  <th>Action</th>
                  <th>Status</th>
                  <th>ID</th>
                  <th>Name</th>
                  <!-- <th>Status</th> -->
                </tr>
              </thead>

              <tbody>
                <tr v-for="sms in smsList" :key="sms.smsTemplateId">
                  <td>
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success"
                        name="smstempArchive1"
                        data-toggle="modal"
                        data-target=""
                        :disabled="updButton == 0"
                        @click="updateClick(sms.smsTemplateId)"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        :disabled="delButton == 0"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          href="javascript:void(0)"
                          id="smstempArchive"
                          @click="updateSms(sms.smsTemplateId, 2, 'delete')"
                          >Delete</a
                        >
                      </div>
                    </div>
                  </td>
                  <th>
                    <div v-if="sms.isStatus == 'Draft'">
                      <span class="bs-label label-warning badgeBorder">
                        {{ sms.isStatus }}
                      </span>
                    </div>
                    <div v-if="sms.isStatus == 'Approved'">
                      <span class="bs-label label-success badgeBorder">
                        {{ sms.isStatus }}
                      </span>
                    </div>
                    <div v-if="sms.isStatus == 'Pending'">
                      <span class="bs-label label-warning badgeBorder">
                        {{ sms.isStatus }}
                      </span>
                    </div>
                    <div v-if="sms.isStatus == 'Rejected'">
                      <span class="bs-label label-danger badgeBorder">
                        {{ sms.isStatus }}
                      </span>
                    </div>
                  </th>
                  <th>SMST-{{ sms.smsTemplateIdSerial }}</th>
                  <th>{{ sms.name }}</th>
                  <!-- <th>{{ sms.isActive ? "Active" : "Inactive" }}</th> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- Send a Text Modal v2 -->
    <div
      class="modal bs-example-modal-lg fade"
      id="sendTextv2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Add SMS Template</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="row">
            <div class="col-5">
              <button
                style="margin-top: 17px; margin-left: 53px"
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                @click="addClick('Draft')"
                id="addSms_btn"
              >
                Save as Draft
              </button>
            </div>
            <div class="col-2"></div>
            <div class="col-5">
              <button
                style="margin-top: 17px; margin-left: -52px"
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                @click="addClick('Approval')"
                id="addSms_btn"
              >
                Save
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">SMS</h3>
                      <div class="form-group">
                        <select
                          class="form-control custom-select"
                          @change="setMerge()"
                          v-model="mergeValue"
                        >
                          <option value="" selected>
                            Select tag to Insert
                          </option>
                          <option value="@FirstName ">First Name</option>
                          <option value="@LastName ">Last Name</option>
                          <option value="@DOB ">DoB</option>
                          <option value="@Phone ">Phone</option>
                          <option value="@Email ">Email</option>
                          <option value="@DOS ">DOS</option>
                          <option value="@Visit Type ">Visit Type</option>
                          <option value="@Visit Reason ">Visit Reason</option>
                          <option value="@Physician ">Physician</option>
                          <option value="@Street ">Street</option>
                          <option value="@City ">City</option>
                          <option value="@State ">State</option>
                          <option value="@zip ">zip</option>
                          <option value="@Primary Insurance Name ">Primary Insurance Name</option>
                          <option value="@Primary Insurance Number ">Primary Insurance Number</option>
                          <option value="@Primary Insurance Group ID ">Primary Insurance Group ID</option>
                          <option value="@Secondary Insurance Name ">Secondary Insurance Name</option>
                          <option value="@Secondary Insurance Number ">Secondary Insurance Number</option>
                          <option value="@Secondary Insurance Group ID ">Secondary Insurance Group ID</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name"
                          required=""
                          maxlength="40"
                          v-model="tempName"
                        />
                      </div> 
                      <div class="form-group">
                        <Editor v-model="tempText" editorStyle="height: 200px">
                          <template #toolbar>
                            <span class="ql-formats"> </span>
                          </template>
                        </Editor>
                        <!-- <textarea
                          class="form-control"
                          rows="15"
                          id="tempText1"
                          placeholder="Enter text ..."
                          required=""
                          v-model="tempText"
                        >
                        </textarea> -->
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Send a Text Modal v2 -->

    <!-- Update a Text Modal v2 -->
    <div
      class="modal bs-example-modal-lg fade"
      id="updateTextv2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Update SMS Template</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="row">
            <div class="col-5">
              <button
                style="margin-top: 17px; margin-left: 53px"
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                @click="updateSms(ssmt.smsTemplateId, 1, 'Draft')"
                id="UpdSms_btn"
              >
                Save as Draft
              </button>
            </div>
            <div class="col-2"></div>
            <div class="col-5">
              <button
                style="margin-top: 17px; margin-left: -52px"
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                @click="updateSms(ssmt.smsTemplateId, 1, 'Approval')"
                id="UpdSms_btn"
              >
                Submit for Approval
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">SMS</h3>
                      <div class="form-group">
                        <select
                          class="form-control custom-select"
                          @change="setMerge1()"
                          v-model="mergeValue1"
                        >
                          <option value="" selected>
                            Select tag to Insert
                          </option>
                          <option value="@FirstName ">First Name</option>
                          <option value="@LastName ">Last Name</option>
                          <option value="@DOB ">DoB</option>
                          <option value="@Phone ">Phone</option>
                          <option value="@Email ">Email</option>
                          <option value="@DOS ">DOS</option>
                          <option value="@Visit Type ">Visit Type</option>
                          <option value="@Visit Reason ">Visit Reason</option>
                          <option value="@Physician ">Physician</option>
                          <option value="@Street ">Street</option>
                          <option value="@City ">City</option>
                          <option value="@State ">State</option>
                          <option value="@zip ">zip</option>
                          <option value="@Primary Insurance Name ">Primary Insurance Name</option>
                          <option value="@Primary Insurance Number ">Primary Insurance Number</option>
                          <option value="@Primary Insurance Group ID ">Primary Insurance Group ID</option>
                          <option value="@Secondary Insurance Name ">Secondary Insurance Name</option>
                          <option value="@Secondary Insurance Number ">Secondary Insurance Number</option>
                          <option value="@Secondary Insurance Group ID ">Secondary Insurance Group ID</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name"
                          maxlength="40"
                          v-model="ssmt.name"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <Editor
                          v-model="ssmt.smsText"
                          editorStyle="height: 200px"
                        >
                          <template #toolbar>
                            <span class="ql-formats"> </span>
                          </template>
                        </Editor>
                        <!-- <textarea
                          class="form-control"
                          rows="15"
                          placeholder="Enter text..."
                          v-model="ssmt.smsText"
                        ></textarea> -->
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Update a Text Modal v2 -->
  </div>
</template>

<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";

export default {
  name: "smsTemplates",

  data() {
    return {
      practName: "",
      practAdd: "",
      userNme: "",
      userEmal: "",
      rtpD: "",

      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      mergeValue: "",
      mergeValue1: "",

      //loader
      loader: "",
      //Timer
      TimerObject: {},
      smsList: [],
      ssmt: {},

      tempName: "",
      tempText: "",
    };
  }, // data

  methods: {
    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },

    setMerge() {
     //debugger
      var e = $(".ql-editor")[0];
      if (document.getSelection().baseNode.data) { 
        var selectedData = document.getSelection().baseNode.data;
        var changeNode = document.getSelection().baseNode.data;
        var selectedIndex = document.getSelection().focusOffset;
        if(selectedData.length <=  selectedIndex){
          selectedIndex = selectedData.length;
        }
        selectedData = [selectedData.slice(0, selectedIndex),this.mergeValue,selectedData.slice(selectedIndex),].join("");
        this.tempText = this.tempText.replace(changeNode, selectedData);      
      } 
      else {

        this.tempText = this.tempText + " " + this.mergeValue;
     
        }
    },

    setMerge1() {
     //debugger
       var e = $(".ql-editor")[1];
      if (document.getSelection().baseNode.data == "undefined") {
      var selectedData = document.getSelection().baseNode.data;
      var changeNode = document.getSelection().baseNode.data;
      var selectedIndex = document.getSelection().focusOffset;

       if(selectedData.length <=  selectedIndex){
          selectedIndex = selectedData.length;
        }
        
      selectedData = [
        selectedData.slice(0, selectedIndex),
        this.mergeValue1,
        selectedData.slice(selectedIndex),
      ].join("");
      this.ssmt.smsText = this.ssmt.smsText.replace(changeNode, selectedData);
      
      }else{
    this.ssmt.smsText = this.ssmt.smsText + " " + this.mergeValue1;
      } 
    },
    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter(
          (i) => i.name == "SMS Template"
        );
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
        if (this.val[0].canDelete == 0) {
          this.delButton = 0;
        }
        if (this.val[0].canCreate == 0) {
          $("button[name=aSms]").hide();
        }
      }
    },
    //Timer
   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    updateSms(id, what, status) {
      let passData = {};
      if (status == "Draft") {
        $("#UpdSms_btn").prop("disabled", true);
        this.intDummyComm();
        this.dummyComm.extras = id + this.UKEY + what;
        this.ssmt.isStatus = "Draft";
        const str = localStorage.OSversion;
        const arr = str.split(this.UKEY);
        this.dummyComm.patientId = arr[0];
        passData = {
          dc: this.dummyComm,
          ssmt: this.ssmt,
        };
      } else if (status == "delete") {
        $("#UpdSms_btn").prop("disabled", true);
        this.intDummyComm();
        this.dummyComm.extras = id + this.UKEY + what;
        passData = {
          dc: this.dummyComm,
          ssmt: this.ssmt,
        };
      } else {
        $("#UpdSms_btn").prop("disabled", true);
        this.intDummyComm();
        this.dummyComm.extras = id + this.UKEY + what;
        this.ssmt.isStatus = "Pending";
        this.ssmt.PracticeName = this.practName;
        this.ssmt.PracticeAddress = this.practAdd;
        this.ssmt.RTPId = this.rtpD;
        this.ssmt.UserName = this.userNme;
        this.ssmt.Email = this.userEmal;
        const str = localStorage.OSversion;
        const arr = str.split(this.UKEY);
        this.dummyComm.patientId = arr[0];
        passData = {
          dc: this.dummyComm,
          ssmt: this.ssmt,
        };
      }
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/UPDSMSTMP",
        data: passData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            if (what == 1) $("#updateTextv2").modal("hide");
            this.loadInit();
            //this.$forceUpdate();
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
          $("#UpdSms_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    }, // updateSMS

    //

    updateClick(id) {
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTSNGSMSTMP";

      this.axiosGetData(url, 2);
    },

    addClick(status) {
      let passData = {};
      if (status == "Draft") {
        if (this.tempName == "") {
          this.ShowWarning("Please Add a Template");
          return;
        }
        if (this.tempText == "") {
          this.ShowWarning("Please Enter Some Text");
          return;
        }
        $("#addSms_btn").prop("disabled", true);
        this.intDummyComm();
        const str = localStorage.OSversion;
        const arr = str.split(this.UKEY);
        this.dummyComm.patientId = arr[0];
        passData = {
          dc: this.dummyComm,
          ssmt: {
            name: this.tempName,
            smsText: this.tempText,
            isStatus: "Draft",
            PracticeName: this.practName,
            PracticeAddress: this.practAdd,
            RTPId: this.rtpD,
            UserName: this.userNme,
            Email: this.userEmal,
          },
        };
      } else {
        if (this.tempName == "") {
          this.ShowWarning("Please Add a Template");
          return;
        }
        if (this.tempText == "") {
          this.ShowWarning("Please Enter Some Text");
          return;
        }
        $("#addSms_btn").prop("disabled", true);
        this.intDummyComm();
        const str = localStorage.OSversion;
        const arr = str.split(this.UKEY);
        this.dummyComm.patientId = arr[0];
        passData = {
          dc: this.dummyComm,
          ssmt: {
            name: this.tempName,
            smsText: this.tempText,
            isStatus: "Approved",
            PracticeName: this.practName,
            PracticeAddress: this.practAdd,
            RTPId: this.rtpD,
            UserName: this.userNme,
            Email: this.userEmal,
          },
        };
      }
      //alert(passData.question + '      ' + this.quest.question);
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/ADDSMS",
        data: passData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag > 0) {
            createToast("Information Added", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            $("#sendTextv2").modal("hide");
            this.loadInit();
          } else {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
          this.tempName = "";
          this.tempText = "";

          $("#addSms_btn").prop("disabled", false);
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    }, // addClick

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = this.myTitle + this.UKEY;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTSMSLST";

      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          //loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            //loader.hide();
            $("#smsList").DataTable().destroy();
            this.smsList = res.data.smsList;
          } else if (what === 2) {
            this.ssmt = res.data.ssmt;
            $("#updateTextv2").modal("show");
          }
          if (what === 101) {
            //loader.hide();
            this.smsList = res.data.smsList;
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    clearTimeout(this.loadObj);
    this.practName = localStorage.getItem("PracticeName");
    this.practAdd = localStorage.getItem("PracticeAddress");
    this.rtpD = localStorage.getItem("RTPID");
    this.userNme = localStorage.getItem("UserName");
    this.userEmal = localStorage.getItem("Email");
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },

  watch: {
    smsList: function () {
      //var one = this;
      try {
        this.$nextTick(() => {
          $("#smsList").DataTable().destroy();
          $("#smsList").DataTable({
            pageLength: 50,
            lengthMenu: [
              [50, 100, 500, 1000, 2000],
              [50, 100, 500, 1000, 2000],
            ],
          });

          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $("#smsList").DataTable().draw();
        });
      } catch {
        alert("catch");
      }
    },
  },
};
</script>

<style>
</style>